import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class ContractDistributionsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/contract_distributions", { params: toSnakeCase(params) });
  }

  fetch(id) {
    return securedAxiosInstance.get(`/contract_distributions/${id}`);
  }
}

export default new ContractDistributionsService();
